import React from 'react'
import Navigation from '../components/header/Navigation';
import ApplyKnowledgeBody from '../components/body/ApplyKnowledgeBody';

const ApplyKnowledge = () => {
    return (
        <React.Fragment>
            <Navigation />
            <ApplyKnowledgeBody />
        </React.Fragment>
    )
};

export default ApplyKnowledge;